
















import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Component, Prop } from 'vue-property-decorator';
import { INormalizedNavItem, actions, NAVIGATION_NAMESPACE } from '../../store/modules/navigation';
import type { OmitFirst } from '../../types';
import { smarticoService } from '../../services';

const navigationModule = namespace(NAVIGATION_NAMESPACE);

@Component
export default class SmarticoWidgetNavigationItem extends Vue {
    @Prop({ type: Object })
    item!: INormalizedNavItem;

    @Prop({ type: Boolean, default: false })
    topNavVariant!: boolean;

    @navigationModule.Action('toggleMainMenu')
    toggleMenu!: OmitFirst<typeof actions.toggleMainMenu>;

    async openSmarticoWidget() {
        const opened = await smarticoService.openGamificationWidget();

        if (opened) {
            this.toggleMenu();
        }
    }
}
